// Parses createApiClient's thrown message: "API error <status>: <raw body>".
// The admin API returns business-rule errors (400 unknown brand/source, 404, 409 duplicates and
// FK-blocked deletes) as a flat JSON body { "error": "<message>" }; the shared client throws a bare
// Error with the raw body concatenated into the message. Returns the server's message when present,
// else undefined (callers fall back to the raw message).
export function extractServerError(err: unknown): string | undefined {
  if (!(err instanceof Error)) return undefined;
  // [\s\S] instead of the dotAll /s flag — the app's tsconfig targets pre-es2018 regex flags.
  const m = err.message.match(/^API error \d+: ([\s\S]*)$/);
  if (!m) return undefined;
  try {
    const parsed: unknown = JSON.parse(m[1]);
    if (parsed && typeof parsed === "object" && "error" in parsed) {
      const message = (parsed as { error: unknown }).error;
      return typeof message === "string" ? message : undefined;
    }
    return undefined;
  } catch {
    return undefined;
  }
}

// The standard catch-handler description for forms and list delete handlers.
export function describeApiError(err: unknown): string {
  return extractServerError(err) ?? (err instanceof Error ? err.message : "Request failed");
}
